import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormFile = () => (
  <ComponentDocs name="<FormFile/>" entry="FormFile" propsEntry="FormFileProps">
    <ComponentExample
      name="Button file picker"
      import={import("examples/Forms/FormFile/ButtonFilePickerExample")}
      rawImport={import("examples/Forms/FormFile/ButtonFilePickerExample?raw")}
    />
    <ComponentExample
      name="Dropzone file picker"
      import={import("examples/Forms/FormFile/DropzoneFilePickerExample")}
      rawImport={import(
        "examples/Forms/FormFile/DropzoneFilePickerExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormFile;
